<template>
  <job-content-table title="志向の指定">
    <job-content-table-outline
      v-for="(workStyle,i) in matching.workStyleList"
      :key="`work-style-${i}`"
      :title="workStyle.name"
      :target-id="targetIdMap.matching.workStyle.list[i]"
      :value="createJoinedText(workStyle.labelList)"
      :comment-highlights="getCommentHighlights(targetIdMap.matching.workStyle.list[i])"
      :highlight-mode="highlightMode"
      v-on="$listeners"
    />
  </job-content-table>
</template>

<script>
import JobContentTable from '@/components/atoms/JobContentTable'
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'
import jobMatchingCommon from '@/lib/jobMatchingCommon'

export default {
  components: {
    JobContentTable,
    JobContentTableOutline
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight, jobMatchingCommon],
  props: {
    matching: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    }
  }
}
</script>
